import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Header } from '../Assets';
import './Layout.css';

const serv = [
    {name:'Signposting', link:'Signposting'}, 
    // {name:'Benefit Advice', link:'Benefits'},
    {name:'Mobility Advice', link:'Mobility'},
    // {name:'Health and Welbeing', link:'HealthAndWellbeing'},
    {name:'Technology Support', link:'TechnologySupport'},
    // {name:'Supporting VIPs', link:'CarersAndBusiness'},
    // {name:'Peer Support', link:'PeerSupport'},
    {name:'Contact Us', link:'ContactUs'}
];

function createLinks(i) { 
    return (
        <Link to={i.link} className='linkee'>
            <div className='link'>
                <div className="link-text">{i.name}</div>
            </div>
        </Link> 
    )
};

// function toggleNav(e) {
//     let currentVisibility = document.getElementById('nav-menu').classList;
//     if (currentVisibility.value !='hide-this') document.getElementById('nav-menu').className = 'hide-this';
//     else document.getElementById('nav-menu').className = '';
//     console.log(document.getElementById('nav-menu').classList);
    
// }


function Layout() {
  return (
    <div>
        <Link to=''>
            <header className="App-header">
                <Header />
            </header>
        </Link>
        {/* <div id="mini-menu" onClick={toggleNav}>
            <FontAwesomeIcon icon={faBars} />
            menu
        </div> */}
        <nav id='nav-menu'>
            {serv.map(i => createLinks(i))}
        </nav>

        <Outlet />
    </div>
  )
}

export default Layout